export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/components/nav-bar-home/side-menu/SideMenu.tsx"